"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Refl = exports.Equal = exports.Objekt = exports.ClazzFulfilled = exports.ClazzCons = exports.ClazzNull = exports.Sole = exports.Trivial = exports.Quote = exports.String = exports.Cons = exports.Sigma = exports.FnImplicit = exports.Fn = exports.PiImplicit = exports.Pi = exports.Type = exports.TypedNeutral = exports.isPatternVar = exports.PatternVar = void 0;
const Neutrals = __importStar(require("../neutral"));
function PatternVar(type, name) {
    return TypedNeutral(type, Neutrals.PatternVar(name));
}
exports.PatternVar = PatternVar;
function isPatternVar(value) {
    return (value["@kind"] === "TypedNeutral" && value.neutral["@kind"] === "PatternVar");
}
exports.isPatternVar = isPatternVar;
function TypedNeutral(type, neutral) {
    return {
        "@type": "Value",
        "@kind": "TypedNeutral",
        type,
        neutral,
    };
}
exports.TypedNeutral = TypedNeutral;
function Type() {
    return {
        "@type": "Value",
        "@kind": "Type",
    };
}
exports.Type = Type;
function Pi(argType, retTypeClosure) {
    return {
        "@type": "Value",
        "@kind": "Pi",
        argType,
        retTypeClosure,
    };
}
exports.Pi = Pi;
function PiImplicit(argType, retTypeClosure) {
    return {
        "@type": "Value",
        "@kind": "PiImplicit",
        argType,
        retTypeClosure,
    };
}
exports.PiImplicit = PiImplicit;
function Fn(retClosure) {
    return {
        "@type": "Value",
        "@kind": "Fn",
        retClosure,
    };
}
exports.Fn = Fn;
function FnImplicit(retClosure) {
    return {
        "@type": "Value",
        "@kind": "FnImplicit",
        retClosure,
    };
}
exports.FnImplicit = FnImplicit;
function Sigma(carType, cdrTypeClosure) {
    return {
        "@type": "Value",
        "@kind": "Sigma",
        carType,
        cdrTypeClosure,
    };
}
exports.Sigma = Sigma;
function Cons(car, cdr) {
    return {
        "@type": "Value",
        "@kind": "Cons",
        car,
        cdr,
    };
}
exports.Cons = Cons;
function String() {
    return {
        "@type": "Value",
        "@kind": "String",
    };
}
exports.String = String;
function Quote(data) {
    return {
        "@type": "Value",
        "@kind": "Quote",
        data,
    };
}
exports.Quote = Quote;
function Trivial() {
    return {
        "@type": "Value",
        "@kind": "Trivial",
    };
}
exports.Trivial = Trivial;
function Sole() {
    return {
        "@type": "Value",
        "@kind": "Sole",
    };
}
exports.Sole = Sole;
function ClazzNull(name) {
    return {
        "@type": "Value",
        "@kind": "ClazzNull",
        name,
    };
}
exports.ClazzNull = ClazzNull;
function ClazzCons(propertyName, propertyType, restClosure, name) {
    return {
        "@type": "Value",
        "@kind": "ClazzCons",
        propertyName,
        propertyType,
        restClosure,
        name,
    };
}
exports.ClazzCons = ClazzCons;
function ClazzFulfilled(propertyName, propertyType, property, rest, name) {
    return {
        "@type": "Value",
        "@kind": "ClazzFulfilled",
        propertyName,
        propertyType,
        property,
        rest,
        name,
    };
}
exports.ClazzFulfilled = ClazzFulfilled;
function Objekt(properties) {
    return {
        "@type": "Value",
        "@kind": "Objekt",
        properties,
    };
}
exports.Objekt = Objekt;
function Equal(type, from, to) {
    return {
        "@type": "Value",
        "@kind": "Equal",
        type,
        from,
        to,
    };
}
exports.Equal = Equal;
function Refl(type, value) {
    return {
        "@type": "Value",
        "@kind": "Refl",
        type,
        value,
    };
}
exports.Refl = Refl;
//# sourceMappingURL=Value.js.map